import { render, staticRenderFns } from "./StepsPhysicalResolution.vue?vue&type=template&id=5f22daac&scoped=true&"
import script from "./StepsPhysicalResolution.vue?vue&type=script&lang=js&"
export * from "./StepsPhysicalResolution.vue?vue&type=script&lang=js&"
import style0 from "./StepsPhysicalResolution.vue?vue&type=style&index=0&id=5f22daac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f22daac",
  null
  
)

export default component.exports